import { FadeIn, ChapterHeading } from './Reveal';
import { useLang } from '../i18n/LangContext';

export const EventsSection = () => {
  const { t } = useLang();
  const EVENT_CARDS = t.events.cards;
  const EVENT_HIGHLIGHTS = t.events.highlights;
  return (
  <section id="dogadjaji" data-testid="events-section" className="relative bg-krug-navy py-24 md:py-32 overflow-hidden">
    <div className="absolute -top-32 left-[10%] w-[420px] h-[420px] rounded-full bg-krug-gold/10 blur-[130px]" aria-hidden="true" />
    <div className="max-w-7xl mx-auto px-5 md:px-8 relative">
      <ChapterHeading
        number="05"
        eyebrow={t.events.eyebrow}
        title={t.events.title}
        copy={t.events.copy}
      />

      <div className="mt-14 grid sm:grid-cols-2 lg:grid-cols-4 gap-5">
        {EVENT_CARDS.map((card, i) => (
          <FadeIn key={card.tag} delay={i * 0.08}>
            <article
              data-testid={`event-card-${i}`}
              className="group relative h-full overflow-hidden rounded-3xl glass-dark p-7 hover:border-krug-gold/40 transition-colors duration-500"
            >
              <div className="absolute -top-10 -right-10 w-32 h-32 rounded-full bg-krug-gold/10 group-hover:bg-krug-gold/20 transition-colors duration-500" aria-hidden="true" />
              <span className="inline-flex items-center justify-center w-12 h-12 rounded-2xl bg-krug-gold/15 text-krug-goldbright">
                <card.icon size={22} />
              </span>
              <h3 className="mt-6 font-heading text-xl font-extrabold text-white">{card.tag}</h3>
              <p className="mt-2.5 text-sm text-slate-400 leading-relaxed">{card.copy}</p>
            </article>
          </FadeIn>
        ))}
      </div>

      <FadeIn delay={0.25}>
        <ul data-testid="event-highlights" className="mt-10 flex flex-wrap justify-center gap-2.5">
          {EVENT_HIGHLIGHTS.map((h) => (
            <li key={h} className="rounded-full border border-krug-tealbright/25 bg-krug-teal/10 px-4 py-2 text-xs md:text-sm font-medium text-krug-tealbright">
              {h}
            </li>
          ))}
        </ul>
      </FadeIn>
    </div>
  </section>
  );
};
